module.exports = __webpack_public_path__ + "img/03.00a7cb8.png";